export enum SidebarPermissions {
  sidemenuAll = 'sidemenuAll',
  sidemenuProfile = 'sidemenuProfile',
  sidemenuOwnGrowth = 'sidemenuOwnGrowth',
  sidemenuTargets = 'sidemenuTargets',
  sidemenuMeetings = 'sidemenuMeetings',
  sidemenuRanking = 'sidemenuRanking',
  sidemenuScoreGrids = 'sidemenuScoreGrids',
  sidemenuPyramids = 'sidemenuPyramids',
  sidemenuEmployees = 'sidemenuEmployees',
  sidemenuNotes = 'sidemenuNotes',
  sidemenuYourCompany = 'sidemenuYourCompany',
  sidemenuAllCompanies = 'sidemenuAllCompanies',
  sidemenuHRSettings = 'sidemenuHRSettings',
  sidemenuDashboard = 'sidemenuDashboard',
  sidemenuGlobalAdmin = 'globalAdmin',
  sidemenuDownloads = 'downloads',
  sidemenuKudos = 'sidemenuKudos',
  sidemenuAttentionPoints = 'sidemenuAttentionPoints',
}
